export default __webpack_public_path__ + "static/Image079-89865033bd1cd5693c52c7172dcf577a.png";